import { render } from "./ProgramTypeComponent.vue?vue&type=template&id=2c641af9"
import script from "./ProgramTypeComponent.vue?vue&type=script&lang=js"
export * from "./ProgramTypeComponent.vue?vue&type=script&lang=js"

import "./ProgramTypeComponent.vue?vue&type=style&index=0&id=2c641af9&lang=css"

import exportComponent from "D:\\Projects\\SCFHSHealthAcademy\\SCFHSHealthAcademyPublic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__